"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VoiceButton;
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton/IconButton.js"));
var _Tooltip = _interopRequireDefault(require("@mui/material/Tooltip/Tooltip.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _Mic = _interopRequireDefault(require("../icons/Mic"));
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function VoiceButton({
  iconProps,
  onClick,
  onTextChange,
  ...rest
}) {
  const {
    isListening,
    startListening,
    stopListening,
    text
  } = (0, _hooks.useVoice)();
  (0, _hooks.useUpdateEffect)(() => {
    onTextChange(text);
  }, [text]);
  function handleClick(e) {
    onClick?.(e);
    if (isListening) stopListening();else startListening();
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    open: isListening,
    PopperProps: {
      sx: {
        pointerEvents: 'inherit'
      }
    },
    title: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        children: "Listening..."
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        color: "warning",
        onClick: stopListening,
        children: "Stop"
      })]
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
      onMouseDown: e => e.preventDefault(),
      onClick: handleClick,
      ...rest,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Mic.default, {
        ...iconProps
      })
    })
  });
}